export default "__VITE_ASSET__i0uF50t2__"